import React from 'react';
import ReactDOM from 'react-dom';
import { Router, Route, browserHistory, IndexRoute, } from 'react-router';
import firebase from 'firebase';
import ReactGA from 'react-ga';

import App from './App';
import Results from './Results';
import Welcome from './Welcome';
import Call from './Call';
import Tweet from './Tweet';
import Email from './Email';
import './index.css';

// Initialize Firebase
const config = {
  apiKey: "AIzaSyAbVmSuzdv9Xc08g6DDFIE1sEcCoYCVvmo",
  authDomain: "representatives-9871f.firebaseapp.com",
  databaseURL: "https://representatives-9871f.firebaseio.com",
  storageBucket: "representatives-9871f.appspot.com",
  messagingSenderId: "1085682450850"
};

ReactGA.initialize('UA-315022-1');

function logPageView() {
  ReactGA.set({ page: window.location.pathname });
  ReactGA.pageview(window.location.pathname);
}

firebase.initializeApp(config);

const Container = (props) => (
  <div>
    <App firebase={firebase}>
      {props.children}
    </App>
  </div>
);

ReactDOM.render((
  <Router history={browserHistory} onUpdate={logPageView} >
    <Route path="/:appId" component={Container}>
      <IndexRoute component={Welcome} />
      <Route path="results/:zipCode" component={Results} />
      <Route path="call/:id" component={Call} />
      <Route path="tweet/:id" component={Tweet} />
      <Route path="email/:id" component={Email} />
      <Route path="*" component={Welcome} />
    </Route>
  </Router>
  ),
  document.getElementById('root')
);




// WEBPACK FOOTER //
// ./src/index.js